import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trivia-map',
  templateUrl: './trivia-map.component.html',
  styleUrls: ['./trivia-map.component.scss']
})
export class TriviaMapComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
